module.exports = __webpack_public_path__ + "static/media/Voting-amico.ea571eb6.svg";